<template>
  <div>
    <div id="labs">
      <div class='labItem'>
        <p class='dataTitle'>总分销销量
          <el-tooltip
            class="item"
            effect="dark"
            content="截至当前，所有分销渠道分销成功的订单数."
            placement="top-start"
          >
            <i
              class="el-icon-warning"
              style="position: relative;left:5%;"
            ></i>
          </el-tooltip>
        </p>
        <p class='dataNumber'><span>{{findData.orderNumber}}</span>&nbsp;<span style="font-size:28px;">单</span></p>
        <p class='dataLine'>————————————————</p>
        <p class='monthNumber'><span>本月销量</span>&nbsp;&nbsp; <span>{{findMonthData.orderNumberMonth}}单</span></p>
      </div>

      <div class='labItem'>
        <p class='dataTitle'>分销销售额
          <el-tooltip
            class="item"
            effect="dark"
            content="客户在线上支付的总额."
            placement="top-start"
          >
            <i
              class="el-icon-warning"
              style="position: relative;left:5%;"
            ></i>
          </el-tooltip>
        </p>
        <p class='dataNumber'><span>{{findData.commission}}</span>&nbsp;<span style="font-size:28px;">元</span></p>
        <p class='dataLine'>————————————————</p>
        <p class='monthNumber'><span>本月销售额</span>&nbsp;&nbsp; <span>{{findMonthData.commissionMonth}}元</span></p>
      </div>

      <div class='labItem'>
        <p class='dataTitle'>掌上通推广员总数
          <el-tooltip
            class="item"
            effect="dark"
            content="目前具有绑定关系的推广员总数."
            placement="top-start"
          >
            <i
              class="el-icon-warning"
              style="position: relative;left:5%;"
            ></i>
          </el-tooltip>
        </p>
        <p class='dataNumber'><span>{{findData.headCount}}</span>&nbsp;<span style="font-size:28px;">个</span></p>
        <p class='dataLine'>————————————————</p>
        <p class='monthNumber'><span>本月增加</span>&nbsp;&nbsp; <span>{{findMonthData.headCountMonth}}个</span></p>
      </div>

      <div
        class='labItem'
        style="margin-right:20px"
      >
        <p class='dataTitle'>掌上通分销成功的推广员
          <el-tooltip
            class="item"
            effect="dark"
            content="截至目前，成功分销出去产品的推广员人数."
            placement="top-start"
          >
            <i
              class="el-icon-warning"
              style="position: relative;left:5%;"
            ></i>
          </el-tooltip>
        </p>
        <p class='dataNumber'><span>{{findData.totalCount}}</span>&nbsp;<span style="font-size:28px;">个</span></p>
        <p class='dataLine'>————————————————</p>
        <p class='monthNumber'><span>本月增加</span>&nbsp;&nbsp; <span>{{findMonthData.totalCountMonth}}个</span></p>
      </div>
    </div>
    <basic-container>

      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <div
          class="labsDatePickercss"
          style="width:800px;display:flex;"
        >
          <div style="width: 500px;">
            <el-date-picker
              v-model="labsDatePicker"
              type="datetimerange"
              size="small"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            >
            </el-date-picker>
          </div>
          <el-button
            size="small"
            style="height:32px;margin-left: 10px;"
            @click="chooseClick"
          >查询</el-button>
          <el-button
            size="small"
            style="height:32px;margin-left: 5px;"
            @click="chooseClear"
          >清空</el-button>
        </div>
        <el-tab-pane
          label="分销销量"
          name="first"
        >
          <div style="display:flex;">
            <div
              id="numberChart"
              style="width:1100px;height:400px;"
            ></div>
            <div>
              <p><span style='font-size: 18px;font-weight: 800;'>分销热门商品榜单</span></p>
              <ul>
                <li
                  v-for="item in hotProducts"
                  :key='item.index'
                  :value='item'
                  style="display:flex;justify-content: space-between;width:250px; margin:25px 0;"
                >
                  <span
                    class='index'
                    v-if="item.index < 4"
                  >{{item.index}}</span>
                  <span
                    class='outdex'
                    v-else
                  >{{item.index}}</span>
                  <span
                    class='otherdex'
                    style='width:60%'
                  >{{item.goodsName}}</span>
                  <span
                    class='otherdex'
                    style='width:20%'
                  >{{item.number}}单</span>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="分销销售额"
          name="second"
        >
          <div style="display:flex;">
            <div
              id="moneyChart"
              style="width:1100px;height:400px;"
            ></div>
            <div>
              <p><span style='font-size: 18px;font-weight: 800;'>分销热门商品榜单</span></p>
              <ul>
                <li
                  v-for="item in hotProducts"
                  :key='item.index'
                  :value='item'
                  style="display:flex;justify-content: space-between;width:250px; margin:25px 0;"
                >
                  <span
                    class='index'
                    v-if="item.index < 4"
                  >{{item.index}}</span>
                  <span
                    class='outdex'
                    v-else
                  >{{item.index}}</span>
                  <span
                    class='otherdex'
                    style='width:60%'
                  >{{item.goodsName}}</span>
                  <span
                    class='otherdex'
                    style='width:20%'
                  >{{item.number}}单</span>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <basic-container>
      <el-tabs
        v-model="activeZstName"
        @tab-click="handleClick"
      >
        <div
          class="labsDatePickercss"
          style="width:800px;display:flex;"
        >
          <div style="width: 500px;">
            <el-date-picker
              v-model="prosDatePicker"
              type="datetimerange"
              size="small"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            >
            </el-date-picker>
          </div>
          <el-button
            size="small"
            style="height:32px;margin-left: 10px;"
            @click="chooseProClick"
          >查询</el-button>
          <el-button
            size="small"
            style="height:32px;margin-left: 5px;"
            @click="chooseProClear"
          >清空</el-button>
        </div>
        <el-tab-pane
          label="掌上通推广员总数"
          name="first"
        >
          <div style="display:flex;">
            <div
              id="promotionChart"
              style="width:1100px;height:400px;"
            ></div>
            <div>
              <p><span style='font-size: 18px;font-weight: 800;'>推广员分销战绩榜单</span></p>
              <ul>
                <li
                  v-for="item in promotionIndex"
                  :key='item.index'
                  :value='item'
                  style="display:flex;justify-content: space-between;width:250px; margin:25px 0;"
                >
                  <span
                    class='index'
                    v-if="item.index < 4"
                  >{{item.index}}</span>
                  <span
                    class='outdex'
                    v-else
                  >{{item.index}}</span>
                  <span
                    class='otherdex'
                    style='width:60%'
                  >{{item.name}}</span>
                  <span
                    class='otherdex'
                    style='width:20%'
                  >{{item.number}}单</span>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>

<script>
import {
  findDataByMonth,
  findData,
  moneyCollect,
  numberCollect,
  rankingByGoodsName,
  rankingByName,
  findNumber
} from "@/api/salesCloud/saleView";
import {
  findFinancialList,
  addPledge,
  findLineData,
  findTotalMoney,
  findFinancialListGet
} from "@/api/salesCloud/financial";
import { formatterDateToUTC } from "@/util/util";

export default {
  name: "saleView",
  data() {
    return {
      chooseDate1: "",
      findData: {},
      labsDatePicker: "",
      prosDatePicker: "",
      startTime: "",
      endTime: "",
      activeName: "first",
      activeZstName: "first",
      engineerNumber: [],
      findMonthData: {},
      numberChartOption: {},
      moneyChartOption: {},
      promotionChartOption: {},
      chooseDate2: "",
      hotProducts: [],
      numberData: {},
      moneyData: {},
      promotionData: {},
      promotionIndex: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    let date = new Date();
    date.setDate(1);
    date.setHours(0);
    date.setSeconds(0);
    date.setMinutes(0);
    let startTime = date.getTime(); //取当年当月中的第一天
    let endTime = new Date().getTime();
    let params = { startTime, endTime };
    this.startTime = formatterDateToUTC(startTime)
      .split(" ", 1)
      .join("");
    this.endTime = formatterDateToUTC(endTime)
      .split(" ", 1)
      .join("");
    findDataByMonth(params).then(res => {
      let data = JSON.parse(res.data);
      this.$nextTick(() => {
        this.findMonthData = data;
      });
    });

    rankingByGoodsName().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        console.log((data[i].index = i + 1));
      }
      this.hotProducts = data;
    });

    rankingByName().then(res => {
      let data = JSON.parse(res.data);
      console.log(res);
      for (let i = 0; i < data.length; i++) {
        console.log((data[i].index = i + 1));
      }
      this.promotionIndex = data;
    });
    findData().then(res => {
      let data = JSON.parse(res.data);
      this.$nextTick(() => {
        this.findData = data;
      });
    });
  },
  watch: {
    lineSearchData: function() {
      console.log("watch", this.lineSearchData);
      this.lineSearchData = this.lineSearchData;
    }
  },
  mounted() {
    // this.lineCharthandle();
    this.numberChartHandle();
    this.moneyChartHandle();
    this.promotionChartHandle();
  },
  computed: {},
  props: [],
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    promotionChartHandle() {
      let params = {};
      params.startTime = this.startTime;
      params.endTime = this.endTime;
      findNumber(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.promotionData = data;
        let promotionChart = echarts.init(
          document.getElementById("promotionChart")
        );
        this.promotionChart = promotionChart;
        let promotionChartOption = {
          title: {
            text: "推广员总数趋势"
          },
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: ["推广员"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          // toolbox: {
          //保存为图片
          // feature: {
          //   saveAsImage: {}
          // }
          // },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.promotionData.dateList
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "推广员",
              type: "line",
              stack: "总量1",
              data: this.promotionData.numberList
              // data: [200, 100, 80]
            }
          ]
        };
        this.promotionChartOption = promotionChartOption;
        promotionChart.setOption(promotionChartOption);
      });
    },
    numberChartHandle() {
      let params = {};
      params.startTime = this.startTime;
      params.endTime = this.endTime;

      numberCollect(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.numberData = data;
        let numberChart = echarts.init(document.getElementById("numberChart"));
        this.numberChart = numberChart;
        let numberChartOption = {
          title: {
            text: "分销销量趋势"
          },
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: ["工程师APP", "掌上通", "商户APP"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          toolbox: {
            //保存为图片
            // feature: {
            //   saveAsImage: {}
            // }
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.numberData.dateList
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "工程师APP",
              type: "line",
              stack: "总量1",
              data: this.numberData.engineerNumberList
            },
            {
              name: "掌上通",
              type: "line",
              stack: "总量2",
              data: this.numberData.appletNumberList
            },
            {
              name: "商户APP",
              type: "line",
              stack: "总量3",
              data: this.numberData.merchantNumberList
            }
          ]
        };
        console.log(numberChartOption);
        this.numberChartOption = numberChartOption;
        setTimeout(() => {
          numberChart.setOption(this.numberChartOption);
        }, 0);
      });
    },
    moneyChartHandle() {
      let params = {};
      params.startTime = this.startTime;
      params.endTime = this.endTime;
      moneyCollect(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.moneyData = data;
        let moneyChart = echarts.init(document.getElementById("moneyChart"));
        this.moneyChart = moneyChart;
        let moneyChartOption = {
          title: {
            text: "分销销售额趋势"
          },
          tooltip: {
            trigger: "axis"
          },
          legend: {
            data: ["工程师APP", "掌上通", "商户APP"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          // toolbox: {
          //保存为图片
          // feature: {
          //   saveAsImage: {}
          // }
          // },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.moneyData.dateList
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "工程师APP",
              type: "line",
              stack: "总量1",
              data: this.moneyData.merchantMoneyList
              // data: [200, 100, 80]
            },
            {
              name: "掌上通",
              type: "line",
              stack: "总量2",
              data: this.moneyData.appletMoneyList
            },
            {
              name: "商户APP",
              type: "line",
              stack: "总量3",
              data: this.moneyData.engineerMoneyList
            }
          ]
        };
        this.moneyChartOption = moneyChartOption;
        moneyChart.setOption(this.moneyChartOption);
      });
    },
    chooseClear() {
      this.startTime = "";
      this.endTime = "";
      this.labsDatePicker = "";
      // this.endTime = new Date();
      // this.startTime = new Date();
    },
    chooseProClear() {
      this.startTime = "";
      this.endTime = "";
      this.prosDatePicker = "";
      // this.endTime = new Date();
      // this.startTime = new Date();
    },
    chooseClick() {
      console.log(this);
      if (
        null != this.labsDatePicker &&
        undefined != this.labsDatePicker &&
        "" != this.labsDatePicker
      ) {
        this.startTime = this.labsDatePicker[0].getTime();
        this.endTime = this.labsDatePicker[1].getTime();
        if (
          this.labsDatePicker[1].getTime() - this.labsDatePicker[0].getTime() >
          1000 * 60 * 60 * 24 * 92
        ) {
          this.$message({
            showClose: true,
            message: "查询时间不能超过三个月",
            type: "error"
          });
          return;
        }
        this.startTime = formatterDateToUTC(this.startTime)
          .split(" ", 1)
          .join("");
        this.endTime = formatterDateToUTC(this.endTime)
          .split(" ", 1)
          .join("");

        let parmas = { startTime: this.startTime, endTime: this.endTime };
        numberCollect(parmas).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          this.numberData.dateList = data.dateList;
          this.numberData.merchantNumberList = data.merchantNumberList;
          this.numberData.engineerNumberList = data.engineerNumberList;
          this.numberData.appletNumberList = data.appletNumberList;
          // this.numberChart.setOption(this.numberChartOption);
          this.numberChartHandle();
        });
        moneyCollect(parmas).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          this.moneyData.dateList = data.dateList;
          this.moneyData.merchantNumberList = data.merchantNumberList;
          this.moneyData.engineerNumberList = data.engineerNumberList;
          this.moneyData.appletNumberList = data.appletNumberList;
          // this.numberChart.setOption(this.numberChartOption);
          this.moneyChartHandle();
        });
      } else {
        this.$message({
          showClose: true,
          message: "查询时间不能为空",
          type: "error"
        });
      }
    },
    chooseProClick() {
      console.log(this);
      if (
        null != this.prosDatePicker &&
        undefined != this.prosDatePicker &&
        "" != this.prosDatePicker
      ) {
        this.startTime = this.prosDatePicker[0].getTime();
        this.endTime = this.prosDatePicker[1].getTime();
        if (
          this.prosDatePicker[1].getTime() - this.prosDatePicker[0].getTime() >
          1000 * 60 * 60 * 24 * 92
        ) {
          this.$message({
            showClose: true,
            message: "查询时间不能超过三个月",
            type: "error"
          });
          return;
        }
        this.startTime = formatterDateToUTC(this.startTime)
          .split(" ", 1)
          .join("");
        this.endTime = formatterDateToUTC(this.endTime)
          .split(" ", 1)
          .join("");

        let parmas = { startTime: this.startTime, endTime: this.endTime };
        findNumber(parmas).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          this.promotionData.dateList = data.dateList;
          this.promotionData.numberList = data.numberList;
          // this.numberChart.setOption(this.numberChartOption);
          this.promotionChartHandle();
        });
      } else {
        this.$message({
          showClose: true,
          message: "查询时间不能为空",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss">
#labs {
  width: 100%;
  // border-radius: 4px;
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
  // height: 100%;
  // overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: 0 10px;
  margin-bottom: 10px;
  .labItem {
    width: 23%;
    height: 165px;
    background-color: #fff;
    .dataTitle {
      position: relative;
      left: 10%;
      top: 10%;
      color: rgba(143, 148, 154, 1);
    }
    .dataNumber {
      position: relative;
      font-size: 30px;
      left: 10%;
      top: 4%;
    }
    .dataLine {
      position: relative;
      top: 15%;
      color: rgba(233, 233, 233, 1);
      text-align: center;
    }
    .monthNumber {
      position: relative;
      top: 10%;
      left: 10%;
      color: rgba(74, 74, 74, 1);
    }
  }
}
.labsDatePickercss {
}
.index {
  background: #314659;
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: block;
  line-height: 20px;
  color: #fff;
  text-align: center;
}
.outdex {
  background: #ddd;
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: block;
  line-height: 20px;
  color: #333;
  text-align: center;
}
.otherdex {
  line-height: 20px;
}
#charts {
  display: flex;
  background: #fff;
  margin: 1px 10px;
  justify-content: space-around;
}
.as {
  position: relative;
  top: -1px;
  display: flex;
  justify-content: flex-end;
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
